var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseView',[(!_vm.isReady)?_c('Loading'):_c('HandleInvitationFlow',{attrs:{"invitation":_vm.invitation,"peopleAdapter":_vm.peopleAdapter},on:{"join":_vm.performJoin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }